/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Contract Management API
 * API for Contract management UI.
 * OpenAPI spec version: 1.0.0-Draft
 */
import * as axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  VinDetail
} from '../../models';




  export const getVehicle = (axiosInstance: AxiosInstance = axios.default) => {
/**
 * Retrieves vehicle information from VIPS and the vehicle health report URI. Works independently of contract availability — can be called even when no contract exists for the VIN.
 * @summary Gets vehicle details and health report for a VIN
 */
const getVinDetail = (
    vin: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<VinDetail>> => {
    return axiosInstance.get(
      `/vin/${vin}`,options
    );
  }
return {getVinDetail}};
export type GetVinDetailResult = AxiosResponse<VinDetail>
